import { Injectable } from '@angular/core';
import { PermissionService } from './permission.service';

@Injectable({
  providedIn: 'root'
})
export class StorageService {


  constructor(private permissionService: PermissionService) { /* empty */ }

  setToken(token: string): void {
    localStorage.setItem('token', token);
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }

  removeToken(): void {
    localStorage.removeItem('token');
  }

  setUser(data: unknown): void {
    console.log('StorageService - setUser called with:', data);
    localStorage.setItem('user', JSON.stringify(data));
    console.log('StorageService - calling refreshFromLocalStorage');
    this.permissionService.refreshFromLocalStorage();
  }

  getUser() {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  }

  removeUser(): void {
    localStorage.removeItem('user');
  }

  clearAll(): void {
    localStorage.clear();
  }

  isLoggedIn(): boolean {
    return !!this.getToken();
  }
}
